var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "defalut-page" }, [
      _c("div", [
        _c("img", {
          attrs: {
            src:
              "https://wlmvp-cos.weiling.cn/website/static/images/default-env.svg",
            alt: "default"
          }
        }),
        _c("div", [_vm._v(" 请在微信中打开观看该直播 ")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }